import React, { FC } from 'react';
import { useFormContext } from 'react-hook-form';

import { FormControl } from '@letsdothis/lds/lib/experimental/FormControl';

import { FieldWrapperProps } from '../types';
import { getErrorMessage } from '../utils';

const FieldWrapper: FC<FieldWrapperProps> = (props) => {
  const { errors } = useFormContext();
  const {
    id,
    required = false,
    children,
    title,
    error,
    hideLabel,
    description,
  } = props;

  const errorMessage = getErrorMessage({ errors, error, id, title });
  const label = hideLabel ? null : `${title}${required ? '*' : ''}`;

  return (
    <div>
      <FormControl
        label={label}
        caption={description || null}
        error={errorMessage || null}
      >
        {children}
      </FormControl>
    </div>
  );
};

export default FieldWrapper;
